module.exports = "<router-outlet></router-outlet>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/angular/DineroAgil/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main